import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const moduleDevice = {
  namespaced: true,
  state: {
    deviceList: [],
  },
  mutations: {
    setDeviceList(state, data) {
      state.deviceList = data;
    },
  },
  actions: {
    async fetchDeviceList({ commit }, { clinicUrl, branchUrl }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "fetchDeviceList")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      try {
        const res = await axios.get(
          `/api/device/${clinicUrl}/${branchUrl}`,
          { skipGlobalErrorHandler: true }
        );
        const items = Array.isArray(res.data) ? res.data : (res.data.data || []);
        commit("setDeviceList", items);
        return res;
      } catch (err) {
        console.error("fetchDeviceList failed", err);
        throw err;
      }
    },

    createDevice(_, { clinicUrl, branchUrl, deviceName }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "createDevice")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .post(
          `/api/device/${clinicUrl}/${branchUrl}`,
          { deviceName },
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    updateDevice(_, { clinicUrl, branchUrl, deviceId, data }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "updateDevice")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .patch(
          `/api/device/${clinicUrl}/${branchUrl}/${deviceId}`,
          data,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    deleteDevice(_, { clinicUrl, branchUrl, deviceId }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "deleteDevice")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .delete(
          `/api/device/${clinicUrl}/${branchUrl}/${deviceId}`,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },

    rotateDeviceKey(_, { clinicUrl, branchUrl, deviceId }) {
      if (!validateClinicBranchParams(clinicUrl, branchUrl, "rotateDeviceKey")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }
      return axios
        .post(
          `/api/device/${clinicUrl}/${branchUrl}/${deviceId}/rotate`,
          {},
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => { throw err; });
    },
  },
  getters: {
    getDeviceList: state => {
      return state.deviceList;
    },
  },
};

export default moduleDevice;
